"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  ${dir("rtl")`
    transform: scaleX(-1);
  `}
`;
const RelatedContent = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M2 15c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5zm0-9c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5C2.672 7.5 2 6.834 2 6zm5 0c0-.414.341-.75.744-.75h13.512c.411 0 .744.333.744.75 0 .414-.341.75-.744.75H7.744A.745.745 0 0 1 7 6zm0 3.5c0-.414.341-.75.744-.75h13.512c.411 0 .744.333.744.75 0 .414-.341.75-.744.75H7.744A.745.745 0 0 1 7 9.5zm0 9c0-.414.341-.75.744-.75h13.512c.411 0 .744.333.744.75 0 .414-.341.75-.744.75H7.744A.745.745 0 0 1 7 18.5zM7 15c0-.414.341-.75.744-.75h13.512c.411 0 .744.333.744.75 0 .414-.341.75-.744.75H7.744A.745.745 0 0 1 7 15z", children: " " })
] });
var RelatedContent_default = RelatedContent;
export {
  RelatedContent_default as default
};
